const SIGN_IN_ERRORS = {
	accountDisabled: "This account has been disabled",
	// The user closed the popup themselves: nothing to report.
	dismissed: null,
	existsWithOtherMethod: "This email already has an account. Sign in with your password",
	invalidCredentials: "Invalid email or password",
	loginFailed: "Login failed",
	methodUnavailable: "This sign-in method isn't enabled for this site",
	networkError: "Network error. Check your connection",
	noAccount: "No account found with this email",
	popupBlocked: "Popup blocked. Allow popups for this site",
	tooManyAttempts: "Too many attempts. Try again later",
	wrongPassword: "Incorrect password",
} as const;

type SignInErrorKey = keyof typeof SIGN_IN_ERRORS;

type Matcher = readonly [needles: readonly string[], key: SignInErrorKey];

const MATCHERS: readonly Matcher[] = [
	[["invalid-credential", "INVALID_LOGIN_CREDENTIALS"], "invalidCredentials"],
	[["user-not-found"], "noAccount"],
	[["wrong-password"], "wrongPassword"],
	[["too-many-requests"], "tooManyAttempts"],
	[["user-disabled"], "accountDisabled"],
	[["network-request-failed"], "networkError"],
	[["popup-closed-by-user", "cancelled-popup-request"], "dismissed"],
	[["popup-blocked"], "popupBlocked"],
	[["account-exists-with-different-credential"], "existsWithOtherMethod"],
	[["unauthorized-domain", "operation-not-allowed"], "methodUnavailable"],
];

/** Maps a Firebase sign-in failure to the sentence shown under the form; null when nothing should show. */
export function signInErrorMessage(error: unknown): string | null {
	if (!(error instanceof Error)) return SIGN_IN_ERRORS.loginFailed;
	const code = "code" in error && typeof error.code === "string" ? error.code : "";
	const reason = code || error.message;
	const key = MATCHERS.find(([needles]) => needles.some((needle) => reason.includes(needle)))?.[1];
	return SIGN_IN_ERRORS[key ?? "loginFailed"];
}
